import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../../components/Base';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "ListRow-root_1hWLf"
};
function ListRow({
  children,
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsx(Base, {
    flex: true,
    flexNoWrap: true,
    className: clsx(styles.root, className),
    ...extraProps,
    children: children
  });
}
export default ListRow;